import { isEqual } from "lodash";
import { FC } from "react";
import { PiTrashDuotone } from "react-icons/pi";
import { Button } from "rizzui";
import CustomSelect from "../../../components/forms/CustomSelect";
import DateField from "../../../components/forms/DateField";
import useUsers from "../../../hooks/api-calls/useUsers";
import { activeInactiveOptions, pickupMessagesTypes, yesNoOptions } from "../../../utils/SelectorMapping";

interface PickupGlobalMessageFiltersProps {
    filters: any;
    updateFilters: (filters: any) => void;
}

const PickupGlobalMessageFilters: FC<PickupGlobalMessageFiltersProps> = ({
    filters,
    updateFilters,
}) => {

    // HOOKS
    const { getUsersList } = useUsers();


    // RENDER

    return (
        <>
            {/* Creator Filter */}
            <CustomSelect
                id="user"
                label="Usuarios"
                placeholder="usuarios"
                options={getUsersList() || []}
                value={filters.filter_filters?.user ? getUsersList()?.filter(user => filters.filter_filters?.user.includes(user.value)) || [] : []}
                onChange={(value: any) => updateFilters({ user: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
                isSearchable={true}
                isLoading={!getUsersList()}
            />

            {/* Start Date Filter */}
            <DateField
                isClearable
                className="w-full"
                label="Fecha de inicio"
                placeholderText="Selecciona las fechas de inicio"
                startDate={filters.filter_filters?.start_date?.from ? new Date(filters.filter_filters.start_date.from) : null}
                endDate={filters.filter_filters?.start_date?.to ? new Date(filters.filter_filters.start_date.to) : null}
                onChange={(date: any) => {
                    const filters_start_date = filters.filter_filters?.start_date;
                    const start_date = date ? { from: date[0], to: date[1] } : null;

                    if (start_date && !isEqual(filters_start_date, start_date)) {
                        updateFilters({ start_date });
                    } else if (!start_date && filters_start_date) {
                        updateFilters({ start_date: null });
                    }
                }}
            />

            {/* End Date Filter */}
            <DateField
                isClearable
                className="w-full"
                label="Fecha de fin"
                placeholderText="Selecciona las fechas de fin"
                startDate={filters.filter_filters?.end_date?.from ? new Date(filters.filter_filters.end_date.from) : null}
                endDate={filters.filter_filters?.end_date?.to ? new Date(filters.filter_filters.end_date.to) : null}
                onChange={(date: any) => {
                    const filters_end_date = filters.filter_filters?.end_date;
                    const end_date = date ? { from: date[0], to: date[1] } : null;

                    if (end_date && !isEqual(filters_end_date, end_date)) {
                        updateFilters({ end_date });
                    } else if (!end_date && filters_end_date) {
                        updateFilters({ end_date: null });
                    }
                }}
            />

            {/* Message Type Filter */}
            <CustomSelect
                id="type"
                label="Tipo de mensaje"
                placeholder="Selecciona el tipo"
                options={pickupMessagesTypes}
                value={filters.filter_filters?.type ? pickupMessagesTypes.filter(type => filters.filter_filters?.type?.includes(type.value)) || [] : []}
                onChange={(value: any) => updateFilters({ type: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
                isSearchable={false}
            />

            {/* Active Status Filter */}
            <CustomSelect
                id="active"
                label="Estado"
                placeholder="Selecciona el estado"
                options={activeInactiveOptions}
                value={filters.filter_filters?.active !== undefined ? activeInactiveOptions.find(option => option.value === filters.filter_filters.active) || null : null}
                onChange={(value: any) => updateFilters({ active: value?.value === 'null' ? null : value?.value })}
                isClearable={true}
                isMulti={false}
                isSearchable={false}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de actualización"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.updated_at?.from ? new Date(filters.filter_filters.updated_at.from) : null}
                endDate={filters.filter_filters?.updated_at?.to ? new Date(filters.filter_filters.updated_at.to) : null}
                onChange={(date: any) => {
                    const filters_updated_at = filters.filter_filters?.updated_at;
                    const updated_at = date ? { from: date[0], to: date[1] } : null;

                    if (updated_at && !isEqual(filters_updated_at, updated_at)) {
                        updateFilters({ updated_at });
                    } else if (!updated_at && filters_updated_at) {
                        updateFilters({ updated_at: null });
                    }
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de creación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.created_at?.from ? new Date(filters.filter_filters.created_at.from) : null}
                endDate={filters.filter_filters?.created_at?.to ? new Date(filters.filter_filters.created_at.to) : null}
                onChange={(date: any) => {
                    const filters_created_at = filters.filter_filters?.created_at;
                    const created_at = date ? { from: date[0], to: date[1] } : null;

                    if (created_at && !isEqual(filters_created_at, created_at)) {
                        updateFilters({ created_at });
                    } else if (!created_at && filters_created_at) {
                        updateFilters({ created_at: null });
                    }
                }}
            />

        </>
    );
};

export default PickupGlobalMessageFilters;